module.exports = __webpack_public_path__ + "img/poster_txt_yg.4012e049.png";